module.exports = __webpack_public_path__ + "static/media/AI.e79c6392.png";